<template>
        <div class="font-16px col-lg-6 mt-3">
            <i class="tio-add-circle color-yellow tio-xl" style="vertical-align: bottom"></i> {{ $t('add_member') }}
        </div>
</template>

<script>
export default {
    name: "Team"
}
</script>

<style scoped>
.color-yellow {
    color: #F2B12D;
}
</style>
